<template>
    <b-card align="left">
      <template v-slot:header>
        <b-navbar variant="faded" type="light">
          <b-container>
            <b-row>
              <b-col lg="2">
                <img src="../assets/logo.png" fluid class="logosCS">
              </b-col>
              <b-col lg="8">
                {{pageTitle}}
              </b-col>
              <b-col lg="2"></b-col>
            </b-row>
          </b-container>
        </b-navbar>
      </template>
      <b-container>
        <b-row>
          <b-col lg="1"> </b-col>
          <b-col lg="10">
            <b-container fluid>
              <b-row class="my-1">
                <b-col sm="3">
                  <label for="input-small">Уникальный ИД:</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input v-model="answerId" id="input-small" size="sm" placeholder="Напишите ИД"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-button @click="findQuestionnaire" variant="success">
                    Найти и загрузить
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
          <b-col lg="1">
            <b-spinner v-if="isLoading" label="Loading..."></b-spinner>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="1"></b-col>
          <b-col lg="10">
            <b-alert show v-if="success" variant="success">Анкета найдена <a :href="urlParam">можете продолжить</a></b-alert>
            <b-alert show v-if="info" variant="info">Анкета не найдена</b-alert>
          </b-col>
          <b-col lg="1"></b-col>
        </b-row>
      </b-container>
      <template v-slot:footer>
        <b-container  class="text-right">
          <small>© Customer Service 2020</small>
        </b-container>
      </template>
    </b-card>
</template>

<script>
import RestApi from '../store/RestApi'
import _ from 'lodash'

export default {
  name: 'RecoveryQuestionnaire',
  data () {
    return {
      urlParam: '',
      pageTitle: 'Востановление работы с отложенной анкетой',
      answerId: '',
      isLoading: false,
      info: false,
      success: false,
      objectQuestion: {},
      formId: ''
    }
  },
  methods: {
    findQuestionnaire () {
      this.isLoading = true
      this.info = false
      this.success = false
      this.downloadsData()
    },
    downloadsData () {
      const answerId = this.answerId
      if (_.isEmpty(answerId)) {
        this.info = true
        this.isLoading = false
        return
      }
      RestApi.GetAnswersById(answerId).then((responce) => {
        if (responce.data.length === 0) {
          this.success = false
          this.info = true
          return
        }
        this.objectQuestion = {}
        this.objectQuestion['form_id'] = responce.data[0].QuestionnaireId
        this.urlParam = `#/operator/${this.objectQuestion['form_id']}`
        _.forEach(responce.data, (node) => {
          this.objectQuestion[node.CodeQuestion] = node.Value
        })
        this.storedProgress()
        this.success = true
        this.isLoading = false
      }).catch((error) => {
        this.isLoading = false
        this.success = false
        this.info = true
        console.log(error)
      })
    },
    storedProgress () {
      const parsed = JSON.stringify(this.objectQuestion)
      if (_.isUndefined(this.objectQuestion.form_id)) {
        return false
      }
      console.log(parsed)
      const nameKey = this.objectQuestion.form_id.replace(/-/g, '')
      localStorage.setItem(`forms_${nameKey}`, parsed)
    }
  }
}
</script>

<style scoped>
  .logosCS {
    max-width: 50%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/RecoveryQuestionnaire.vue